export const ValidaEmail = (email) => {
  if (!email) return "Digite seu email";
  else if (
    !email
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  )
    return "Email inválido";
  else return "";
};

export const ValidaSenha = (senha) => {
  if (!senha) return "Digite sua senha";
  else if (senha.length < 6) return "Deve conter pelo menos 6 caracteres";
  else return "";
};

export const ValidaSenha2 = (senha, senha2) => {
  if (!senha2) return "Digite sua senha";
  else if (senha !== senha2) return "As senhas não são iguais";
  else return "";
};

export const ValidaLogin = (erro) => {
  let r = {};

  if (erro === "auth/invalid-email") r.email = "Email inválido";
  else if (erro === "auth/user-not-found") r.email = "Email não cadastrado";

  if (erro === "auth/internal-error") r.senha = "Senha inválida";
  else if (erro === "auth/wrong-password") r.senha = "Senha incorreta";
  else if (erro === "auth/too-many-requests")
    r.senha =
      "Conta bloqueada temporariamente. Tente novamente mais tarde ou redefina sua senha.";

  return r;
};

export const ValidaCadastro = (erro) => {
  let r = {};
  if (erro === "auth/invalid-email") r.email = "Email inválido";
  else if (erro === "auth/email-already-in-use")
    r.email = "Email já cadastrado";

  if (erro === "auth/internal-error") r.senha = "Senha inválida";
  else if (erro === "auth/weak-password") r.senha = "Mínimo de 6 caracteres";

  return r;
};

export const ValidaRedefinir = (erro) => {
  let r = {};

  if (erro === "auth/missing-email") r.email = "Digite seu email";
  else if (erro === "auth/invalid-email") r.email = "Email inválido";
  else if (erro === "auth/user-not-found") r.email = "Email não cadastrado";

  return r;
};

export const ValidaForm1 = (form) => {
  let erro = {};

  if (!form?.nome) erro.nome = "Preencha este campo";
  else if (form?.nome.length < 3) erro.nome = "Nome inválido";

  if (!form?.fone1) erro.fone1 = "Preencha este campo";
  else if (form?.fone1.length < 8 || form?.fone1.length > 14)
    erro.fone1 = "Telefone inválido";
  else if (form?.fone1.length === 8 || form?.fone1.length === 9)
    erro.fone1 = "Insira o DDD também";

  if (!form?.fone2) {
  } else if (form?.fone2.length < 8 || form?.fone2.length > 14)
    erro.fone2 = "Telefone inválido";
  else if (form?.fone2.length === 8 || form?.fone2.length === 9)
    erro.fone2 = "Insira o DDD também";

  if (!form?.endereco1) erro.endereco1 = "Preencha este campo";

  if (!form?.numero1) erro.numero1 = "Preencha este campo";

  if (!form?.cidade) erro.cidade = "Preencha este campo";

  if (!form?.bairro1) erro.bairro1 = "Preencha este campo";

  if (!form?.urlFoto) erro.foto = "Envio obrigatório";

  if (!Object.keys(erro).length) erro = "";

  return erro;
};

export const ValidaLinha = (codigo) => {
  let linha = "";

  if (codigo === "353") linha = "Pelotas x Porto Alegre";
  else if (codigo === "271") linha = "Pelotas x Rio Grande";
  else if (codigo === "271A") linha = "Pelotas x Cassino";
  else if (codigo === "622") linha = "Pelotas x Canguçu";
  else if (codigo === "269") linha = "Pelotas x Piratini";
  else if (codigo === "259") linha = "Pelotas x Piratini";
  else if (codigo === "261") linha = "Pelotas x Chui";
  else if (codigo === "408") linha = "Rio Grande x Chui";
  else if (codigo === "1636") linha = "Canguçu x Piratini";
  else if (codigo === "t") linha = "Válido para todas as linhas";

  return linha;
};
